import React from 'react';
import { motion } from 'framer-motion';

interface ContactHeroSectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  subtitleAr?: string;
  subtitleEn?: string;
}

const ContactHeroSection: React.FC<ContactHeroSectionProps> = ({
  language = 'ar',
  titleAr = 'اتصل بنا',
  titleEn = 'Contact Us',
  subtitleAr = 'نحن هنا لمساعدتك في تحقيق مشروعك',
  subtitleEn = 'We are here to help you achieve your project'
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="relative bg-gradient-to-br from-primary-900 via-primary-800 to-secondary-900 py-20">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center text-white"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            {isRTL ? titleAr : titleEn}
          </h1>
          <p className="text-xl text-primary-100 max-w-3xl mx-auto">
            {isRTL ? subtitleAr : subtitleEn}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactHeroSection; 